import httpApi from '../hooks/api/httpApi';
import { User } from '../models/User';

const getData = async () => {
    const res = await httpApi.get<{ user: User }>(`/api/user/profile`);
    return res.getData();
};

export default {
    getData,
};
